export const SET_ALERT_OPTIONS = 'SET_ALERT_OPTIONS@alert';
